<div [id]="id()" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative max-h-full rounded-lg" [ngClass]="{'w-[30%]': !loading(), 'w-fit': loading()}">
        <div class="relative primary-purple-light-2-background rounded-lg shadow dark:bg-gray-700 p-6">
            @if (!loading()) {
                <form novalidate #form (ngSubmit)="onSubmit()">
                    <section id="header">
                        <div class="flex items-center">
                            <h3 class="w-full text-xl font-bold primary-purple-text dark:text-gray-400">{{ literalService.get('services.modal.exportGTFS.title', true) }}</h3>
                            <button (click)="modal()!.hide()" type="button" class="right-6 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                                <img [src]="images.close" class="h-6 w-6" />
                            </button>
                        </div>
                    </section>
                    <section id="body" class="mt-6">
                        <label class="text-base font-semibold primary-purple-text">{{ literalService.get('services.modal.exportGTFS.text', true) }}</label>
                        <!-- Town Selector -->
                        <section class="flex justify-between mt-8">
                            <article class="w-full">
                                <div class="flex items-center mb-[6px]">
                                    <img [src]="images.area" alt="town" class="h-6 w-6 mr-[6px]" />
                                    <label class="font-normal text-base">{{ literalService.get('services.data.area', true) }}</label>
                                </div>
                                <select2 class="block" [placeholder]="literalService.get('services.modal.selectArea', true)" [data]="allTowns" [value]="selectedTownId" [templates]="{option: option}" (update)="changeTown($event)">
                                    <ng-template #option let-label="label">
                                        <app-select2-option [label]="label" />
                                    </ng-template>
                                </select2>
                            </article>
                        </section>
                        <!-- Services Multi-selector -->
                        @if (services.length > 0) {
                            <section class="mt-6">
                                <div class="flex items-center mb-[6px]">
                                    <img [src]="images.services.client" alt="service" class="h-6 w-6 mr-[6px]" />
                                    <label class="font-normal text-base">{{ literalService.get('services.modal.service', true) }}</label>
                                </div>
                                <!-- Select All + Clear -->
                                <div class="flex mb-3">
                                    <label class="flex box pt-2 pb-2 pl-4 pr-4 rounded h-10 mr-4 items-center cursor-pointer">
                                        <input #selectAllCheckbox type="checkbox" class="mr-2 cursor-pointer" [checked]="true" (change)="selectAll($event)" />
                                        {{ literalService.get('selectAll', true) }}
                                    </label>
                                    <article class="flex box pt-2 pb-2 pl-4 pr-4 rounded h-10 items-center bg-white cursor-pointer" (click)="clearSelection()">
                                        <img class="mr-1 cursor-pointer" [src]="images.booking.actions.delete" alt="clear" />
                                        <label class="cursor-pointer hover:underline">{{ literalService.get('clearSelection', true) }}</label>
                                    </article>
                                </div>
                                <!-- Service checkboxes -->
                                <div class="max-h-60 overflow-y-auto">
                                    @for (service of services; track service.id) {
                                        <label class="flex box pt-2 pb-2 pl-4 pr-4 rounded h-10 mb-2 items-center bg-white cursor-pointer">
                                            <input type="checkbox" class="mr-2 cursor-pointer" [checked]="service.checked" (change)="service.checked = !service.checked" />
                                            {{ getServiceLabel(service) }}
                                        </label>
                                    }
                                </div>
                            </section>
                        }
                        @if (loadingServices) {
                            <section class="mt-6 flex justify-center">
                                <ng-lottie class="w-24" [options]="loadingAnimation" (animationCreated)="utilsService.animationCreated($event, 1)" />
                            </section>
                        }
                    </section>
                    <section id="footer" class="flex mt-10">
                        <input type="button" class="secondary mt-2 gap-4 border-2 font-semibold p-2 w-full uppercase cursor-pointer items-center bg-white mr-1" (click)="modal()!.hide()" [value]="literalService.get('cancel', true)"/>
                        <input type="submit" [disabled]="!hasSelectedServices" class="primary mt-2 gap-4 border-2 font-semibold p-2 w-full uppercase ml-1 cursor-pointer" [value]="literalService.get('export', true)"/>
                    </section>
                </form>
            } @else {
                <article class="flex flex-col w-full justify-center rounded-es-lg rounded-ee-lg">
                    <ng-lottie class="w-80" [options]="exporting" (animationCreated)="utilsService.animationCreated($event, 1)" />
                    <div class="-mt-16 pb-6 flex flex-col w-[75%] mx-auto">
                        <div class="flex justify-between items-center mb-2">
                            <label class="text-[18px] font-semibold primary-purple-light-text">{{ literalService.get('services.modal.exportGTFS.action', true) }}...</label>
                            <label class="text-[18px] font-semibold primary-purple-light-text">{{ loadingPercentage() }}%</label>
                        </div>
                        <div class="flex justify-center">
                            <progress class="progress primary-purple-light-text" [value]="loadingPercentage()" max="100"></progress>
                        </div>
                    </div>
                </article>
            }
        </div>
    </div>
</div>
